import { numberWithCommas } from './mixins.js'


export class calculatorDataDefaults {
  constructor(
    listingFlatRate = "5",
    listingSplitRate1 = "7",
    listingSplitThreshold = "100000",
    listingSplitRate2 = "2.5",
    buyingFlatRate = "2.5",
    buyingSplitRate1 = "3.255",
    buyingSplitThreshold = "100000",
    buyingSplitRate2 = "1.1625") {
    this.listingGrossCommission = {
      flat: {
        rate: {
          value: listingFlatRate
        }
      },
      split: {
        rate1: {
          value: listingSplitRate1
        },
        threshold: {
          value: listingSplitThreshold
        },
        rate2: {
          value: listingSplitRate2
        }
      }
    },
    this.buyingAgentCommission = {
      flat: {
        rate: {
          value: buyingFlatRate
        }
      },
      split: {
        rate1: {
          value: buyingSplitRate1
        },
        threshold: {
          value: buyingSplitThreshold
        },
        rate2: {
          value: buyingSplitRate2
        } 
      }
    }
  }
}

const baseDefaults = new calculatorDataDefaults()

export class flatRateListing {
  constructor(defaults = baseDefaults, updateDefaults = false,) {
    this.type = 'flat'
    this.rate = {
      value: defaults.listingGrossCommission.flat.rate.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.listingGrossCommission.flat.rate.value = this.value
      }
    }
    this.stringify = function() {
      return `${this.rate.value}%`
    }
  }
}

export class flatRateBuying {
  constructor(defaults = baseDefaults, updateDefaults = false,) {
    this.type = 'flat'
    this.rate = {
      value: defaults.buyingAgentCommission.flat.rate.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.buyingAgentCommission.flat.rate.value = this.value
      }
    },
    this.bonus = {
      value: "0",
      isActive: false,
      previous: '',
      decimalLimit: 2,
      type: 'dollar'
    }
    this.stringify = function() {
      let string = `${this.rate.value}%`
      this.bonus.value != "0" ? string += ` + $${numberWithCommas(this.bonus.value)} Bonus` : ''
      return string
    }
  }
}


export class splitRateListing {
  constructor(defaults = baseDefaults, updateDefaults = false) {
    this.type = 'split'
    this.threshold = {
      value: defaults.listingGrossCommission.split.threshold.value,
      isActive: false,
      previous: '',
      decimalLimit: 2,
      type: 'dollar',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.listingGrossCommission.split.threshold.value = this.value
      }
    }
    this.rate1 = {
      value: defaults.listingGrossCommission.split.rate1.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.listingGrossCommission.split.rate1.value = this.value
      }
    }
    this.rate2 = {
      value: defaults.listingGrossCommission.split.rate2.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.listingGrossCommission.split.rate2.value = this.value
      }
    }
    this.stringify = function() {
      return `${this.rate1.value}% to $${numberWithCommas(this.threshold.value)} then ${this.rate2.value}%`
    }
  }
}

export class splitRateBuying {
  constructor(defaults = baseDefaults, updateDefaults = false) {
    this.type = 'split'
    this.threshold = {
      value: defaults.buyingAgentCommission.split.threshold.value,
      isActive: false,
      previous: '',
      decimalLimit: 2,
      type: 'dollar',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.buyingAgentCommission.split.threshold.value = this.value
      }
    }
    this.rate1 = {
      value: defaults.buyingAgentCommission.split.rate1.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.buyingAgentCommission.split.rate1.value = this.value
      }
    }
    this.rate2 = {
      value: defaults.buyingAgentCommission.split.rate2.value,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent',
      updateDefaults: updateDefaults,
      updateDefault() {
        defaults.buyingAgentCommission.split.rate2.value = this.value
      }
    },
    this.bonus = {
      value: "0",
      isActive: false,
      previous: '',
      decimalLimit: 2,
      type: 'dollar'
    }
    this.stringify = function() {
      let string = `${this.rate1.value}% to $${numberWithCommas(this.threshold.value)} then ${this.rate2.value}%`
      this.bonus.value != "0" ? string += ` + $${numberWithCommas(this.bonus.value)} Bonus` : ''
      return string
    }
  }
}

export class commissionData {
  constructor(value = false) {
    this.value = value
  } 
}

export default class calculatorData {
  constructor(
    updateDefaults = false,
    price = "0",
    listingGrossCommissions = new commissionData(),
    buyingAgentCommission = new commissionData(),
    salesTaxRate = "5") {
    this.updateDefaults = updateDefaults
    this.emailShow = false
    this.emailSent = false
    this.emailSending = false
    this.price = {
      value: price,
      isActive: false,
      previous: '',
      decimalLimit: 2,
      type: 'dollar'
    }
    this.listingGrossCommissions = listingGrossCommissions
    this.buyingAgentCommission = buyingAgentCommission
    this.salesTaxRate = {
      value: salesTaxRate,
      isActive: false,
      previous: '',
      decimalLimit: -1,
      type: 'percent'
    }
    this.results = {
    },
    this.resultsString = function() {
      let r = this.results
      let string = ``
      if (this.listingGrossCommissions.value && this.buyingAgentCommission.value) {
        string = 
`Price: $${numberWithCommas(r.price)}
Gross Commission: $${numberWithCommas(r.listingGrossCommissions)}
GST: $${numberWithCommas(r.totalGst)}
Total: $${numberWithCommas(r.total)}
Seller Net Price: $${numberWithCommas(r.sellerNetPrice)}

Buying Agent
---
Portion: $${numberWithCommas(r.buyingAgentPortion)}
GST: $${numberWithCommas(r.buyingAgentGst)}
Total: $${numberWithCommas(r.buyingAgentTotal)}

Listing Agent
---
Portion: $${numberWithCommas(r.listingAgentPortion)}
GST: $${numberWithCommas(r.listingAgentGst)}
Total: $${numberWithCommas(r.listingAgentTotal)}`
      } else if (this.listingGrossCommissions.value) {
        string = 
`Price: $${numberWithCommas(r.price)}
Gross Commission: $${numberWithCommas(r.listingGrossCommissions)}
GST: $${numberWithCommas(r.totalGst)}
Total: $${numberWithCommas(r.total)}`
      } else if (this.buyingAgentCommission.value) {
        string =
`Price: $${r.price}

Buying Agent
---
Portion: $${numberWithCommas(r.buyingAgentPortion)}
GST: $${numberWithCommas(r.buyingAgentGst)}
Total: $${numberWithCommas(r.buyingAgentTotal)}`
      }
      return string
    }
    this.summaryString = function() {
      let string = ''
      if (this.listingGrossCommissions.value && this.buyingAgentCommission.value) {
        string =
`Listing Gross Commissions
${this.listingGrossCommissions.value.stringify()}

Buying Agent Commission
${this.buyingAgentCommission.value.stringify()}`
      } else if (this.listingGrossCommissions.value) {
        string =
`Listing Gross Commissions
${this.listingGrossCommissions.value.stringify()}`
      } else if (this.buyingAgentCommission.value) {
        string =
`Buying Agent Commission
${this.buyingAgentCommission.value.stringify()}`
      }
      return string
    }
    this.collapsed = false,
    this.compared = false
  }
}